(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  // Open all accordions on desktop, allow toggle on mobile
  function handleFooterAccordions() {
    const accordions = document.querySelectorAll('.footer-menu-accordion');
    const isDesktop = window.innerWidth >= 990;
    
    accordions.forEach(accordion => {
      if (isDesktop) {
        accordion.setAttribute('open', '');
      } else {
        accordion.removeAttribute('open');
      }
    });
  }

  // Run on load and resize
  document.addEventListener('DOMContentLoaded', handleFooterAccordions);
  window.addEventListener('resize', handleFooterAccordions);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
